import { render, staticRenderFns } from "./ListaAssinaturas.vue?vue&type=template&id=16faf8b3&"
import script from "./ListaAssinaturas.vue?vue&type=script&lang=js&"
export * from "./ListaAssinaturas.vue?vue&type=script&lang=js&"
import style0 from "./ListaAssinaturas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports